/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/generate-component-builder/index.ts to modify the generation of this file.


import { ComponentBuilder } from '@sitecore-jss/sitecore-jss-nextjs';


import * as Accordion from 'src/jsscomponents/Accordion';
import * as AccountBonus from 'src/jsscomponents/AccountBonus';
import * as AccountCoupons from 'src/jsscomponents/AccountCoupons';
import * as AccountDetails from 'src/jsscomponents/AccountDetails';
import * as AccountJulaClubOverview from 'src/jsscomponents/AccountJulaClubOverview';
import * as AccountJulaClubSignupForm from 'src/jsscomponents/AccountJulaClubSignupForm';
import * as AccountJulaProAddUserForm from 'src/jsscomponents/AccountJulaProAddUserForm';
import * as AccountJulaProDetails from 'src/jsscomponents/AccountJulaProDetails';
import * as AccountJulaProInvoices from 'src/jsscomponents/AccountJulaProInvoices';
import * as AccountJulaProOverview from 'src/jsscomponents/AccountJulaProOverview';
import * as AccountJulaProReferenceDetails from 'src/jsscomponents/AccountJulaProReferenceDetails';
import * as AccountJulaProReferences from 'src/jsscomponents/AccountJulaProReferences';
import * as AccountJulaProSignupForm from 'src/jsscomponents/AccountJulaProSignupForm';
import * as AccountJulaProUserDetails from 'src/jsscomponents/AccountJulaProUserDetails';
import * as AccountJulaProUsers from 'src/jsscomponents/AccountJulaProUsers';
import * as AccountMenu from 'src/jsscomponents/AccountMenu';
import * as AccountOrderDetails from 'src/jsscomponents/AccountOrderDetails';
import * as AccountOrderStatus from 'src/jsscomponents/AccountOrderStatus';
import * as AccountPurchases from 'src/jsscomponents/AccountPurchases';
import * as ActionButton from 'src/jsscomponents/ActionButton';
import * as ActionButtonDouble from 'src/jsscomponents/ActionButtonDouble';
import * as BlogDetails from 'src/jsscomponents/BlogDetails';
import * as BlogOverview from 'src/jsscomponents/BlogOverview';
import * as BrandFilterList from 'src/jsscomponents/BrandFilterList';
import * as BrandHeading from 'src/jsscomponents/BrandHeading';
import * as Breadcrumbs from 'src/jsscomponents/Breadcrumbs';
import * as CampaignViewer from 'src/jsscomponents/CampaignViewer';
import * as Cart from 'src/jsscomponents/Cart';
import * as CategoryIntro from 'src/jsscomponents/CategoryIntro';
import * as ChatButton from 'src/jsscomponents/ChatButton';
import * as Checkout from 'src/jsscomponents/Checkout';
import * as Delivery from 'src/jsscomponents/Checkout/Delivery';
import * as Payment from 'src/jsscomponents/Checkout/Payment';
import * as UserInfo from 'src/jsscomponents/Checkout/UserInfo';
import * as CheckoutIdentificationPage from 'src/jsscomponents/CheckoutIdentificationPage';
import * as ClothingSizes from 'src/jsscomponents/ClothingSizes';
import * as ContactForm from 'src/jsscomponents/ContactForm';
import * as ContactHeading from 'src/jsscomponents/ContactHeading';
import * as ContentBlock from 'src/jsscomponents/ContentBlock';
import * as ContentBlockHighlight from 'src/jsscomponents/ContentBlockHighlight';
import * as ContentBlockInfo from 'src/jsscomponents/ContentBlockInfo';
import * as ContentGuide from 'src/jsscomponents/ContentGuide';
import * as ContentHeading from 'src/jsscomponents/ContentHeading';
import * as ContentHeadline from 'src/jsscomponents/ContentHeadline';
import * as ContentIntroduction from 'src/jsscomponents/ContentIntroduction';
import * as ContentLink from 'src/jsscomponents/ContentLink';
import * as CookieInformation from 'src/jsscomponents/CookieInformation';
import * as CreditWarning from 'src/jsscomponents/CreditWarning';
import * as DataDebugger from 'src/jsscomponents/DataDebugger';
import * as DocumentLink from 'src/jsscomponents/DocumentLink';
import * as DoubleTeaser from 'src/jsscomponents/DoubleTeaser';
import * as FAQArticle from 'src/jsscomponents/FAQArticle';
import * as FAQHeading from 'src/jsscomponents/FAQHeading';
import * as FAQOverview from 'src/jsscomponents/FAQOverview';
import * as FAQSearch from 'src/jsscomponents/FAQSearch';
import * as FAQSupport from 'src/jsscomponents/FAQSupport';
import * as FAQs from 'src/jsscomponents/FAQs';
import * as FindProduct from 'src/jsscomponents/FindProduct';
import * as Flowbox from 'src/jsscomponents/Flowbox';
import * as FocusGridMedia from 'src/jsscomponents/FocusGridMedia';
import * as HiddenHeading from 'src/jsscomponents/HiddenHeading';
import * as InformationNotice from 'src/jsscomponents/InformationNotice';
import * as InspirationLandscape from 'src/jsscomponents/InspirationLandscape';
import * as InspirationOverview from 'src/jsscomponents/InspirationOverview';
import * as MediaBanner from 'src/jsscomponents/MediaBanner';
import * as MediaCaption from 'src/jsscomponents/MediaCaption';
import * as MediaDouble from 'src/jsscomponents/MediaDouble';
import * as MediaDoubleWide from 'src/jsscomponents/MediaDoubleWide';
import * as MediaLandscape from 'src/jsscomponents/MediaLandscape';
import * as MediaLink from 'src/jsscomponents/MediaLink';
import * as MediaSingle from 'src/jsscomponents/MediaSingle';
import * as MediaSquare from 'src/jsscomponents/MediaSquare';
import * as Menu from 'src/jsscomponents/Menu';
import * as NearbyStores from 'src/jsscomponents/NearbyStores';
import * as OpeningHours from 'src/jsscomponents/OpeningHours';
import * as OrderConfirmation from 'src/jsscomponents/OrderConfirmation';
import * as PageFooter from 'src/jsscomponents/PageFooter';
import * as PageHeader from 'src/jsscomponents/PageHeader';
import * as ProductArchiveSearch from 'src/jsscomponents/ProductArchiveSearch';
import * as ProductCarousel from 'src/jsscomponents/ProductCarousel';
import * as ProductDetails from 'src/jsscomponents/ProductDetails';
import * as ProductList from 'src/jsscomponents/ProductList';
import * as PromoHero from 'src/jsscomponents/PromoHero';
import * as PromoStartPage from 'src/jsscomponents/PromoStartPage';
import * as QuestionsAndAnswersForm from 'src/jsscomponents/QuestionsAndAnswersForm';
import * as Quote from 'src/jsscomponents/Quote';
import * as ResursApplicationForm from 'src/jsscomponents/ResursApplicationForm';
import * as SearchResultsPage from 'src/jsscomponents/SearchResultsPage';
import * as SharedWishlist from 'src/jsscomponents/SharedWishlist';
import * as ShortcutBrands from 'src/jsscomponents/ShortcutBrands';
import * as ShortcutChips from 'src/jsscomponents/ShortcutChips';
import * as ShortcutIcons from 'src/jsscomponents/ShortcutIcons';
import * as ShortcutImages from 'src/jsscomponents/ShortcutImages';
import * as ShortcutInspiration from 'src/jsscomponents/ShortcutInspiration';
import * as Spacer from 'src/jsscomponents/Spacer';
import * as Splitter from 'src/jsscomponents/Splitter';
import * as StaffPrice from 'src/jsscomponents/StaffPrice';
import * as StepIndicator from 'src/jsscomponents/StepIndicator';
import * as StoreIntro from 'src/jsscomponents/StoreIntro';
import * as StoreList from 'src/jsscomponents/StoreList';
import * as TeaserCarousel from 'src/jsscomponents/TeaserCarousel';
import * as TestFreaksAllReviews from 'src/jsscomponents/TestFreaksAllReviews';
import * as ThemedIntroductionChips from 'src/jsscomponents/ThemedIntroductionChips';
import * as ThemedProductCarousel from 'src/jsscomponents/ThemedProductCarousel';
import * as TopBanner from 'src/jsscomponents/TopBanner';
import * as TriggerbeeCampaign from 'src/jsscomponents/TriggerbeeCampaign';
import * as USP from 'src/jsscomponents/USP';
import * as Wishlist from 'src/jsscomponents/Wishlist';
import * as YouTubeVideo from 'src/jsscomponents/YouTubeVideo';

export const components = new Map();

components.set('Accordion', Accordion);
components.set('AccountBonus', AccountBonus);
components.set('AccountCoupons', AccountCoupons);
components.set('AccountDetails', AccountDetails);
components.set('AccountJulaClubOverview', AccountJulaClubOverview);
components.set('AccountJulaClubSignupForm', AccountJulaClubSignupForm);
components.set('AccountJulaProAddUserForm', AccountJulaProAddUserForm);
components.set('AccountJulaProDetails', AccountJulaProDetails);
components.set('AccountJulaProInvoices', AccountJulaProInvoices);
components.set('AccountJulaProOverview', AccountJulaProOverview);
components.set('AccountJulaProReferenceDetails', AccountJulaProReferenceDetails);
components.set('AccountJulaProReferences', AccountJulaProReferences);
components.set('AccountJulaProSignupForm', AccountJulaProSignupForm);
components.set('AccountJulaProUserDetails', AccountJulaProUserDetails);
components.set('AccountJulaProUsers', AccountJulaProUsers);
components.set('AccountMenu', AccountMenu);
components.set('AccountOrderDetails', AccountOrderDetails);
components.set('AccountOrderStatus', AccountOrderStatus);
components.set('AccountPurchases', AccountPurchases);
components.set('ActionButton', ActionButton);
components.set('ActionButtonDouble', ActionButtonDouble);
components.set('BlogDetails', BlogDetails);
components.set('BlogOverview', BlogOverview);
components.set('BrandFilterList', BrandFilterList);
components.set('BrandHeading', BrandHeading);
components.set('Breadcrumbs', Breadcrumbs);
components.set('CampaignViewer', CampaignViewer);
components.set('Cart', Cart);
components.set('CategoryIntro', CategoryIntro);
components.set('ChatButton', ChatButton);
components.set('Checkout', Checkout);
components.set('Delivery', Delivery);
components.set('Payment', Payment);
components.set('UserInfo', UserInfo);
components.set('CheckoutIdentificationPage', CheckoutIdentificationPage);
components.set('ClothingSizes', ClothingSizes);
components.set('ContactForm', ContactForm);
components.set('ContactHeading', ContactHeading);
components.set('ContentBlock', ContentBlock);
components.set('ContentBlockHighlight', ContentBlockHighlight);
components.set('ContentBlockInfo', ContentBlockInfo);
components.set('ContentGuide', ContentGuide);
components.set('ContentHeading', ContentHeading);
components.set('ContentHeadline', ContentHeadline);
components.set('ContentIntroduction', ContentIntroduction);
components.set('ContentLink', ContentLink);
components.set('CookieInformation', CookieInformation);
components.set('CreditWarning', CreditWarning);
components.set('DataDebugger', DataDebugger);
components.set('DocumentLink', DocumentLink);
components.set('DoubleTeaser', DoubleTeaser);
components.set('FAQArticle', FAQArticle);
components.set('FAQHeading', FAQHeading);
components.set('FAQOverview', FAQOverview);
components.set('FAQSearch', FAQSearch);
components.set('FAQSupport', FAQSupport);
components.set('FAQs', FAQs);
components.set('FindProduct', FindProduct);
components.set('Flowbox', Flowbox);
components.set('FocusGridMedia', FocusGridMedia);
components.set('HiddenHeading', HiddenHeading);
components.set('InformationNotice', InformationNotice);
components.set('InspirationLandscape', InspirationLandscape);
components.set('InspirationOverview', InspirationOverview);
components.set('MediaBanner', MediaBanner);
components.set('MediaCaption', MediaCaption);
components.set('MediaDouble', MediaDouble);
components.set('MediaDoubleWide', MediaDoubleWide);
components.set('MediaLandscape', MediaLandscape);
components.set('MediaLink', MediaLink);
components.set('MediaSingle', MediaSingle);
components.set('MediaSquare', MediaSquare);
components.set('Menu', Menu);
components.set('NearbyStores', NearbyStores);
components.set('OpeningHours', OpeningHours);
components.set('OrderConfirmation', OrderConfirmation);
components.set('PageFooter', PageFooter);
components.set('PageHeader', PageHeader);
components.set('ProductArchiveSearch', ProductArchiveSearch);
components.set('ProductCarousel', ProductCarousel);
components.set('ProductDetails', ProductDetails);
components.set('ProductList', ProductList);
components.set('PromoHero', PromoHero);
components.set('PromoStartPage', PromoStartPage);
components.set('QuestionsAndAnswersForm', QuestionsAndAnswersForm);
components.set('Quote', Quote);
components.set('ResursApplicationForm', ResursApplicationForm);
components.set('SearchResultsPage', SearchResultsPage);
components.set('SharedWishlist', SharedWishlist);
components.set('ShortcutBrands', ShortcutBrands);
components.set('ShortcutChips', ShortcutChips);
components.set('ShortcutIcons', ShortcutIcons);
components.set('ShortcutImages', ShortcutImages);
components.set('ShortcutInspiration', ShortcutInspiration);
components.set('Spacer', Spacer);
components.set('Splitter', Splitter);
components.set('StaffPrice', StaffPrice);
components.set('StepIndicator', StepIndicator);
components.set('StoreIntro', StoreIntro);
components.set('StoreList', StoreList);
components.set('TeaserCarousel', TeaserCarousel);
components.set('TestFreaksAllReviews', TestFreaksAllReviews);
components.set('ThemedIntroductionChips', ThemedIntroductionChips);
components.set('ThemedProductCarousel', ThemedProductCarousel);
components.set('TopBanner', TopBanner);
components.set('TriggerbeeCampaign', TriggerbeeCampaign);
components.set('USP', USP);
components.set('Wishlist', Wishlist);
components.set('YouTubeVideo', YouTubeVideo);

export const componentBuilder = new ComponentBuilder({ components });

export const moduleFactory = componentBuilder.getModuleFactory();
